<uni-label>
  {{'ci.common.recipientNumber' | translate}}
</uni-label>
<app-form-chips
    (valueChange)="onRecipientChange($event)"
    [value]="value"
    [placeholder]="'ci.common.recipients' | translate"
></app-form-chips>
<small>
  {{'ci.common.recipientsHint' | translate}}
</small>
<uni-form-field-error *ngIf="ngControl.invalid && ngControl.touched && ngControl.errors.required">
    {{'ci.common.fieldRequired' | translate}}
</uni-form-field-error>
<uni-form-field-error *ngIf="ngControl.invalid && ngControl.touched && ngControl.errors.pattern">
    {{'validation.pattern' | translate}}
</uni-form-field-error>